import ApiClient from './client';

const apiClient = new ApiClient(
  process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:6543/api/v1'
);

export default apiClient;
